import styled, { StyledComponent } from 'styled-components'
import { Upload } from 'antd'

export const StyledUpload: StyledComponent<any, any, {}, never> = styled(Upload)`
  width: 128px;
  height: 128px;
`
